// extracted by mini-css-extract-plugin
module.exports = {"loaderDiv":"Game_loaderDiv__K2kiQ","IconExplainerDiv":"Game_IconExplainerDiv__2srxX"};